import { useOAuthStore } from "~/components/_refactored/auth/composables/useOAuthStore";

// /oauth-register is only reachable after a client-side Google OAuth step has
// populated the OAuth store (useGoogleLogin -> setOAuthData -> router.push).
// On a cold SSR / refresh / crawler hit there is no profile, so redirect to
// login instead of server-rendering the registration form — which must never
// run without an OAuth profile (and otherwise wedges the SSR event loop).
export default function ({ redirect, localePath }) {
  const { hasProfile } = useOAuthStore();
  if (!hasProfile.value) {
    return redirect(localePath({ name: "login" }));
  }
}
